export default {
  APP_CONTENT: 'app-content-column',
  MODULES: 'modules-column',
};
